import React from 'react';
import {Icon, Text} from '@albert-io/atomic';

import {CleverClassResult, CleverSyncResults} from './util';
import './sync-result.scss';

interface Props {
  result: CleverClassResult;
}

const SyncResults = ({
  syncResults,
  className
}: {
  syncResults?: CleverSyncResults;
  className?: string;
}) => (
  <div className={`u-overflow-y_auto u-width_100pc ${className}`}>
    {syncResults &&
      syncResults.success &&
      syncResults.results.map((r) => <ClassroomSyncResult key={r.classroom_name} result={r} />)}
  </div>
);

const ClassroomSyncResult = ({result}: Props) => {
  const messageDetails = getMessageDetails(result);
  return (
    <div className='u-display_flex u-justify-content_space-between u-width_100pc u-mar-b_2'>
      <Text
        className='u-text-align_left u-white-space_nowrap u-overflow_hidden u-text-overflow_ellipsis'
        title={result.classroom_name}
      >
        {result.classroom_name}
      </Text>
      <div className='center-padding u-mar-lr_1' />
      <div className='u-display_flex u-align-items_center'>
        <Text className={`u-mar-r_1 u-white-space_nowrap u-color_${messageDetails.statusColor}`}>
          {messageDetails.message}
        </Text>
        <Icon
          icon={messageDetails.icon}
          color='inherit'
          className={`u-color_${messageDetails.statusColor}`}
        />
      </div>
    </div>
  );
};

const getMessageDetails = (result: CleverClassResult): any => {
  if (!result.success) {
    if (
      result.message ===
      "Class was not imported because it was not linked to a school found in Albert's system.\n"
    ) {
      return {
        icon: 'xmark',
        statusColor: 'red-500',
        message: 'No matching school in Albert'
      };
    }
    return {
      icon: 'xmark',
      iconColor: 'danger',
      textColor: 'red',
      message: 'Unknown Error'
    };
  }
  if (result.status === 'archived') {
    return {
      icon: ['far', 'box-archive'],
      message: 'Archived',
      statusColor: 'slate-500'
    };
  }
  return {
    icon: 'check',
    message: 'Synced',
    statusColor: 'green-700'
  };
};

export default SyncResults;
